import React from 'react';
import format from 'date-fns/format';
import { srOnly } from '@domain-group/fe-brary';
import * as styles from './summary.style';
import { Statistics } from '..';
import { OverallStarRating } from '../../../shared/recommendations/types';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../../../shared/average-star-rating-and-total';
import { PROFILE_TIERS } from '../../../../constants';

export type Props = {
  totalForSale?: number | null;
  totalSoldAndAuctioned?: number | null;
  totalJointSoldAndAuctioned?: number | null;
  totalForRent?: number | null;
  totalLeased?: number | null;
  totalJointLeased?: number | null;
  overallStarRating?: OverallStarRating;
  profileTier?: PROFILE_TIERS;
};

const Summary = ({
  totalForSale = null,
  totalSoldAndAuctioned = null,
  totalJointSoldAndAuctioned = null,
  totalForRent = null,
  totalLeased = null,
  totalJointLeased = null,
  overallStarRating,
  profileTier,
}: Props): React.ReactElement => {
  const showRatings =
    overallStarRating && profileTier === PROFILE_TIERS.platinum;

  return (
    <div css={styles.wrapper}>
      <div>
        <h2 css={styles.title}>
          Properties <span css={srOnly}>sales summary</span>
        </h2>
        <p css={styles.subtitle}>
          <span css={srOnly}>Summary for</span> 12 month period to{' '}
          {format(new Date(), 'MMMM d, yyyy')}
        </p>
        {showRatings && (
          <div css={styles.starRatingContainer}>
            <AverageStarRatingAndTotal
              section={STAR_RATING_SECTION.AGENCY_PROPERTY_SUMMARY}
              averageRating={overallStarRating?.rating}
              totalReviews={overallStarRating?.totalReviews}
              scrollTo
            />
          </div>
        )}
        <Statistics
          totalForSale={totalForSale}
          totalSoldAndAuctioned={totalSoldAndAuctioned}
          totalJointSoldAndAuctioned={totalJointSoldAndAuctioned}
          totalForRent={totalForRent}
          totalLeased={totalLeased}
          totalJointLeased={totalJointLeased}
        />
      </div>
    </div>
  );
};

export default Summary;
